"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var link_1 = __importDefault(require("next/link"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
function Logo() {
    var _a;
    var config = (0, swr_hooks_1.useConfig)();
    var _b = (0, react_1.useState)(false), mounted = _b[0], setMounted = _b[1];
    var lang = (0, next_intl_1.useLocale)();
    var data = (0, swr_hooks_1.usePromotions)().data;
    var customLogo = (config === null || config === void 0 ? void 0 : config.customLogo) && (data === null || data === void 0 ? void 0 : data.find(function (promo) { return (promo === null || promo === void 0 ? void 0 : promo.slug) === 'logo-test'; }));
    (0, react_1.useEffect)(function () {
        setMounted(true);
        return function () { return setMounted(false); };
    }, []);
    if (!mounted)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.logoWrapper },
        react_1.default.createElement(link_1.default, { href: "/".concat(lang) }, customLogo ? (react_1.default.createElement("img", { src: (_a = customLogo === null || customLogo === void 0 ? void 0 : customLogo.images) === null || _a === void 0 ? void 0 : _a.banner, alt: "logo" })) : (react_1.default.createElement("img", { src: "/img/logo.svg", alt: "logo" })))));
}
exports.default = Logo;
